export interface InstallationKey {
    ejendomNr: number;
    aktivNr: number;
    installationNr: number;
}
